module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Monaco', {
    attrs: {
      "height": "600",
      "language": "typescript",
      "srcPath": "dist",
      "code": _vm.code,
      "options": _vm.options,
      "highlighted": _vm.highlightLines,
      "changeThrottle": 500,
      "theme": "vs-dark"
    },
    on: {
      "mounted": _vm.onMounted,
      "codeChange": _vm.onCodeChange
    }
  }), _vm._v(" "), _c('Monaco', {
    attrs: {
      "height": "600",
      "language": "typescript",
      "code": _vm.code,
      "options": _vm.options,
      "highlighted": _vm.highlightLines,
      "changeThrottle": 500,
      "theme": "vs-dark"
    },
    on: {
      "mounted": _vm.onMounted2,
      "codeChange": _vm.onCodeChange2
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._v("Log value")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.highlightLines[0].number),
      expression: "highlightLines[0].number"
    }],
    attrs: {
      "placeholder": "primary highlight #"
    },
    domProps: {
      "value": (_vm.highlightLines[0].number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.highlightLines[0].number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.highlightLines[1].number),
      expression: "highlightLines[1].number"
    }],
    attrs: {
      "placeholder": "secondary highlight #"
    },
    domProps: {
      "value": (_vm.highlightLines[1].number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.highlightLines[1].number = $event.target.value
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40c4224a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 50
// module chunks = 0